import { createContext, useContext } from "react";

export const DICTIONARY_MODES = ["define", "translate", "save"] as const;
export type DictionaryMode = (typeof DICTIONARY_MODES)[number];

export type SidebarSelectionContext = "sidebar" | "page";
export type SelectionMenuOwner = SidebarSelectionContext | null;

// The globally-shared slice of DictionaryTools' state. Everything else the
// feature tracks (search text, mode, results) stays local to DictionaryTools.
export type DictionaryToolsContextValue = {
  enabled: boolean;
  isSidebarOpen: boolean;
  openSidebar: (mode: DictionaryMode, selection: string) => void;
  toggleSidebar: () => void;
  closeSidebar: () => void;

  selectionMenuOwner: SelectionMenuOwner;
  updateSelectionState: (
    type: SidebarSelectionContext,
    isContextMenuOpen: boolean
  ) => void;
};

export const DictionaryToolsContext = createContext<
  DictionaryToolsContextValue | undefined
>(undefined);
DictionaryToolsContext.displayName = "DictionaryToolsContext";

export function useDictionaryTools() {
  const context = useContext(DictionaryToolsContext);

  if (!context) {
    throw new Error("Must be used within DictionaryTools");
  }

  return context;
}
